<script>
import { nextTick } from 'vue';
import { generateNewDolu, updateDoluCategories, createOneCategory } from '@/services/MindMovieServices';

export default {
  data() {
    return {
      uId: localStorage.getItem('uId'),
      token: localStorage.getItem('idToken'),
      revealNewForm: false,
      newCategory: '',
    };
  },
  emits: ['new-category-was-created'],
  methods: {
    async revealTheForm() {
      this.revealNewForm = true;
      await nextTick();

      const n = document.getElementById('input-new-category');
      if (n) { n.click(); }
    },

    cancelAdd() {
      this.revealNewForm = false;
      this.newCategory = '';
    },

    async addNewCategoryToMindMovie() {
      // console.log('*** addNewCategoryToMindMovie() ***', this.newCategory);

      const newCat = this.newCategory.trim();
      const n = await createOneCategory(this.uId, this.token, newCat);

      if (!n) {
        alert('Something went wrong while creating new category');
      } else {
        console.log('*** response from createOneCategory ***', n);

        // update dolu.categories in dbase
        const doluString = generateNewDolu();
        await updateDoluCategories(this.uId, this.token, doluString);

        // emit, so MindMovieCategories can add this to the list of categories being displayed
        this.$emit('new-category-was-created', {id: n.name, name: newCat});

        // reset the ui
        this.cancelAdd();
      }

    },
  },
}
</script>

<template>
  <div :class="revealNewForm ? ' bg-grey-lighten-2 ' : ''" class="pa-3">

    <div v-if="revealNewForm">
      <v-textarea v-model="newCategory" id="input-new-category"
                  variant="outlined"
                  rows="1" auto-grow
                  label="Name of new category"
      ></v-textarea>
      <div class="d-flex justify-end">
        <v-btn @click.prevent="cancelAdd" class="mr-3 text-capitalize" color="red-lighten-2">Cancel</v-btn>
        <v-btn @click.prevent="addNewCategoryToMindMovie" class="w-25" color="green-lighten-1">Add</v-btn>
      </div>
    </div>

    <div v-else>
      <v-btn @click.prevent="revealTheForm" color="green-lighten-2 text-capitalize">Create a New Category</v-btn>
    </div>

  </div>
</template>

<style scoped lang="scss">

</style>
